import { __assign } from "tslib";
/* eslint-disable camelcase*/
import { RicosBILogger } from './RicosBILogger';
import uuid from './uuid';
var rce_session_id = uuid();
export var ricosBICallbacks = function (_a) {
    var _b = _a.consumer, container = _b === void 0 ? 'default' : _b, _c = _a.appDefId, container_id = _c === void 0 ? 'empty' : _c, container_platform = _a.platform, post_id = _a.postId, container_usage = _a.usage, content_id = _a.contentId, webBiLogger = _a.webBiLogger;
    var biLogger = new RicosBILogger(webBiLogger);
    var genericParams = {
        container: container,
        container_id: container_id,
        container_platform: container_platform,
        container_usage: container_usage,
        content_id: content_id,
        post_id: post_id,
        rce_session_id: rce_session_id,
    };
    return {
        onPluginAdd: function (plugin_id, entry_point, version) {
            return biLogger.log('addPlugin', __assign(__assign({}, genericParams), { plugin_id: plugin_id,
                entry_point: entry_point,
                version: version }));
        },
        onPluginAddStep: function (args) {
            return biLogger.log('addPluginStep', __assign(__assign({}, genericParams), args));
        },
        onPluginAddSuccess: function (plugin_id, entry_point, version) {
            return biLogger.log('addPluginSuccess', __assign(__assign({}, genericParams), { plugin_id: plugin_id,
                entry_point: entry_point,
                version: version }));
        },
        onPluginDelete: function (plugin_id, version) {
            return biLogger.log('deletePlugin', __assign(__assign({}, genericParams), { plugin_id: plugin_id,
                version: version }));
        },
        onPluginChange: function (plugin_id, pluginDetails, version) {
            return biLogger.log('changePlugin', __assign(__assign({}, genericParams), { plugin_id: plugin_id, plugins_details: JSON.stringify(pluginDetails), 
                // value: { from, to },
                version: version }));
        },
        onPublish: function (postId, plugins_count, _plugins_details, version) {
            return biLogger.log('publishPost', __assign(__assign({}, genericParams), { post_id: postId || post_id, plugins_count: plugins_count && JSON.stringify(plugins_count), plugins_details: '', //plugins_details && JSON.stringify(_plugins_details),
                version: version }));
        },
        onViewerAction: function (plugin_id, action_name, value) {
            return biLogger.log('viewerAction', __assign(__assign({}, genericParams), { action_name: action_name,
                plugin_id: plugin_id,
                value: value }));
        },
        onViewerLoaded: function (preview, version) {
            return biLogger.log('viewerLoaded', __assign(__assign({}, genericParams), { preview: preview,
                version: version }));
        },
        onOpenEditorSuccess: function (version) {
            return biLogger.log('openEditorSuccess', __assign(__assign({}, genericParams), { version: version }));
        },
        onMediaUploadStart: function (correlationId, plugin_id, fileSize, mediaType, version) {
            biLogger.log('uploadMediaTry', __assign(__assign({}, genericParams), { plugin_id: plugin_id,
                correlationId: correlationId,
                fileSize: fileSize,
                mediaType: mediaType,
                version: version }));
        },
        onMediaUploadEnd: function (correlationId, plugin_id, duration, fileSize, mediaType, isSuccess, errorReason, version) {
            biLogger.log('uploadMediaFinished', __assign(__assign({}, genericParams), { plugin_id: plugin_id,
                correlationId: correlationId,
                duration: duration,
                fileSize: fileSize,
                mediaType: mediaType,
                isSuccess: isSuccess,
                errorReason: errorReason,
                version: version }));
        },
    };
};
//# sourceMappingURL=ricosBICallbacks.js.map